import { Link } from "react-router-dom";
import { useState } from "react";
import { useAuthStore } from "../../auth/hooks";
import { useForm } from "../../hooks";
import { AuthLayout } from "../layout";
import { InputForm, LoadingData, ErrorMessage, MainButton } from "../ui";
import { ConfirmCodeSection } from "../sections";
import { useFormMessages } from "../hooks";

const formData = {
  email: "",
};

const formValidations = {
  email: [(value) => value.includes("@"), "El email debe contener una @"],
};

export const ActivateAccountPage = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoading,
    nextStep,
    message,

    // Methods
    startResendSignUpCode,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted, showErrorMessage, messageText } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onSendCode = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startResendSignUpCode(formState);
    }
  };

  // Efectos -----------------------------------------------//

  if (nextStep === "confirm-code") {
    return <ConfirmCodeSection />;
  }

  return (
    <AuthLayout>
      <h4 className="text-center">Activar cuenta</h4>
      <form className="login-form" onSubmit={onSendCode}>
        <div className="row g-3">
          <div className="col-lg-12">
            <p className="text-muted mb-0">
              Por favor ingresa tu dirección de correo electrónico. Recibirás un
              código para activar tu cuenta.
            </p>
          </div>
          {/* Formulario estatico */}
          <>
            <div className="col-lg-12">
              <InputForm
                label={"Correo electrónico"}
                type={"text"}
                validation={formValidation.emailValid}
                submit={validateForm}
                name={"email"}
                value={formState.email}
                onInputChange={onInputChange}
              />
            </div>
          </>
          <div className="col-md-12">
            <div className="d-grid">
              <MainButton type="submit" disabled={isLoading}>
                Enviar
              </MainButton>
            </div>
          </div>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>

          <div className="col-md-12">
            <small className="text-dark me-2">¿Ya activaste tu cuenta?</small>{" "}
            <Link to="/auth/login" className="text-dark h6 mb-0">
              Ingresa
            </Link>
          </div>
        </div>
      </form>
    </AuthLayout>
  );
};
